<template>
	<div>
		<v-form v-show="tab !== 3" ref="form" @submit.prevent="filter">
			<v-row dense align="center">
				<!-- from-date -->
				<v-col lg="2" md="3" sm="4" cols="6">
					<bee-date-picker
						v-model="filterData.fromDate"
						:input-label="$T('inputs.from-date')"
						:input-props="{ dense: true, outlined: true, readonly: true }"
						hide-details
						menu-picker
					/>
				</v-col>

				<!-- to-date -->
				<v-col lg="2" md="3" sm="4" cols="6">
					<bee-date-picker
						v-model="filterData.toDate"
						:input-label="$T('inputs.to-date')"
						:input-props="{ dense: true, outlined: true, readonly: true }"
						hide-details
						menu-picker
					/>
				</v-col>

				<v-col cols="auto">
					<v-btn small type="submit" color="primary">
						<v-icon>$search</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-form>

		<div class="d-flex">
			<div>
				<v-tabs v-model="tab" height="30" class="mt-1" @change="tab !== 3 ? filter() : fetchItemStatistics()">
					<v-tab>{{$T('headers.client')}}</v-tab>
					<v-tab>{{$T('headers.country')}}</v-tab>
					<v-tab>{{$T('headers.provider')}}</v-tab>
					<v-tab>{{$T('sales-availability')}}</v-tab>
				</v-tabs>
				<v-divider class="mb-2"/>
			</div>
			<v-spacer />
			<v-radio-group
				v-if="tab < 2"
				v-model="display"        	
				mandatory
				dense
				row
				color="primary"
				class="rounded mt-0"
				@change="searchId = null"
			>
				<span class="me-2">{{$T('display')}} : </span>
				<v-radio :label="$T('inputs.price-display')" :value="0"></v-radio>
				<v-radio :label="$T('inputs.weight-display')" :value="1"></v-radio>
			</v-radio-group>
		</div>

		<!-- table -->
		<bee-handy-table
			:headers="tab !== 2 ? headers : providerHeaders"
			:items="loading ? [] : statistics"
			:items-per-page="20"
			:loading="loading"
			:height="$vuetify.breakpoint.height - 170"
			:data-table-props="{ disableSort: true }"
			fixed-header
			zebra
			dense
			pagination-on-scroll
			shown-rows-text
			:item-class="item => item.isLast ? 'divider-before' : ''"
		>
			<template v-slot:item.statistics="{ item }">
				<span :class="item.isLast ? 'primary--text font-weight-bold' : ''">{{ item.statistics }}</span>
			</template>
		</bee-handy-table>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { itemCategory } from '@/helpers/enums'
import { fixNumber, toKiloGram } from '@/helpers/functions'
export default {
	name: 'Statistics',

	data() {
		return {
			loading: false,
			tab: 0,

			filterData: {
				// fromDate: moment().subtract('year', 1).format('YYYY-MM-DD'),
				fromDate: null,
				toDate: null,
			},
			statistics: [],
			itemCategory,
			display: 0,
			statisticss: []
		}
	},

	watch: {
		display() {
			if (this.tab !== 2) {
				const items = []
				console.log('statisticss', this.statisticss)
				this.statisticss.forEach((entry) => {
					items.push({
						...entry,
						...this.itemsHeaders.reduce((res, header) => {
							res[header.value] =
								this.display === 0 ? entry.deliveryItems.find(c => c.itemId === header.value)?.price ?? 0 : this.toKiloGram(entry.deliveryItems.find(c => c.itemId === header.value)?.weight ?? 0);
							return res;
						}, {})
					});
				});
				this.statistics = items
			}
		}
	},

	computed: {
		...mapState({
			permissions: state => state.auth.self.permissions,
			cardamomRootId: state => state.configs.itemsConfigs.cardamomRootId,
			items: state => state.items.items,
			itemsTree: state => state.items.itemsTree,
			providerStatistics: state => state.statistics.providerStatistics,
			rawCardamomId: state => state.configs.itemsConfigs.rawCardamomId,
			seedsId: state => state.configs.itemsConfigs.seedsId,
		}),

		...mapGetters({
			getAccountById: 'accounts/getAccountById',
			getItemById: 'items/getItemById'
		}),

		itemsHeaders() {
			const subTreeItemId = this.cardamomRootId || this.itemsTree[0].id;
			if (!subTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === subTreeItemId);

			const headers = [];

			const getHeaderColor = (priority) => {
				switch (priority) {
				case 1: return 'primary-priority-1';
				case 2: return 'secondary-priority-1';
				case 3: return 'thirdly-priority-1';
				default: return '';
				}
			}
			const getCellColor = (priority) => {
				switch (priority) {
				case 1: return 'primary-priority-2';
				case 2: return 'secondary-priority-2';
				}
				if (priority < 10) {
					return `thirdly-priority-${priority - 1}`
				}
				return ''
			}

			subTree.children.filter(c => c.itemCategory === itemCategory.commercial).forEach((c, i) => {
				if (c.children.length) {
					c.children.forEach(e => {
						headers.push({
							text: e.name,
							name: e.name,
							value: e.id,
							align: 'center',
							width: 58,
							type: 'number-format',
							class: getHeaderColor(i < 2 ? i + 1 : 3),
							cellClass: getCellColor(i + 1),
							columnClass: 'px-1'
						})
					});
				} else {
					headers.push({
						text: c.name,
						name: c.name,
						value: c.id,
						align: 'center',
						width: 58,
						type: 'number-format',
						class: getCellColor(i < 2 ? i + 1 : 3),
						cellClass: getCellColor(i + 1),
						columnClass: 'px-1'
					});
				}
			})

			return headers;
		},

		headers() {
			const headers = [
				this.tab === 0
					? {
						text: this.$T('headers.client'),
						name: 'client',
						value: 'clientId',
						setValueExpr: val => this.getAccountById(val)?.name ?? '-'
					}
					: this.tab === 1
						? { text: this.$T('headers.country'), name: 'country', value: 'country' }
						: { text: 'statistics', name: 'statistics', value: 'statistics' },
				...this.itemsHeaders,
				this.tab !== 3 
					? {
						text: this.$T('headers.total-weight'),
						name: 'totalWeight',
						value: 'totalWeight',
						setValueExpr: val => this.$options.filters.numberFormat(this.toKiloGram(val)),
						align: 'center',
					} 
					: null,
				this.tab === 3 
					? {
						text: this.$T('headers.total-weight') + ' (Kg)',
						name: 'totalRow',
						value: 'totalRow',
						align: 'center',
						width: 80,
					} 
					: null,
				this.tab !== 3 
					? {
						text: this.$T('headers.total-price'),
						name: 'totalPrice',
						align: 'center',
						value: 'totalPrice',
					} 
					: null,
				this.tab !== 3 
					? {
						text: this.$T('headers.average-price'),
						name: 'averagePrice',
						align: 'center',
						value: 'averagePrice',
					}
					: null
			];
			const actualHeaders = headers.filter(c => Boolean(c))
			for (let i = 1; i < actualHeaders.length; i++) {
				actualHeaders[i].columnClass = actualHeaders[i].columnClass ? actualHeaders[i].columnClass + ' px-1' : 'px-1';
				actualHeaders[i].type = 'number-format';
			}

			return actualHeaders;
		},

		providerHeaders() {
			const materialsStatistics = [];
			[this.rawCardamomId, this.seedsId].forEach(id => {
				materialsStatistics.push({
					text: this.$T('headers.item'),
					name: id,
					value: id,
					align: 'center',
				});
				materialsStatistics.push({
					text: this.$T('headers.weight'),
					name: 'totalWeight' + id,
					value: 'totalWeight' + id,
					type: 'number-format',
					align: 'center',
					noNotAvailableText: true
				});
				materialsStatistics.push({
					text: this.$T('headers.average-price'),
					name: 'avergePurchasePrice' + id,
					value: 'avergePurchasePrice' + id,
					type: 'number-format',
					align: 'center',
					noNotAvailableText: true,
					divider: true
				});
			})
			return [
				{
					text: this.$T('headers.provider'),
					name: 'provider',
					value: 'providerId',
					setValueExpr: val => this.getAccountById(val)?.name ?? '-',
					divider: true
				},
				...materialsStatistics
			]
		}
	},

	methods: {
		toKiloGram,

		filter() {
			this.loading = true;
			const actionName = this.tab !== 2 ? 'fetchAll' : 'fetchProviderStatistics';
			this.$store.dispatch(`statistics/${actionName}`, {
				fromDate: this.filterData.fromDate,
				toDate: this.filterData.toDate,
				forClient: this.tab === 0
			}).then((data) => {
				this.statisticss = data
				const tableItems = [];
				if (this.tab !== 2) {
					data.forEach((entry) => {
						tableItems.push({
							...entry,
							...this.itemsHeaders.reduce((res, header) => {
								res[header.value] =
									this.display === 0 ? entry.deliveryItems.find(c => c.itemId === header.value)?.price ?? 0 : this.toKiloGram(entry.deliveryItems.find(c => c.itemId === header.value)?.weight ?? 0);
								return res;
							}, {})
						});
					});
				} else {
					tableItems.push(
						...data.map(c => ({
							providerId: c.providerId,
							
							// raw cardamom
							[this.rawCardamomId]: this.getItemById(this.rawCardamomId)?.name ?? '-',
							[`totalWeight${this.rawCardamomId}`]:
								c.providerItems.find(e => e.itemId === this.rawCardamomId)?.totalWeight ?? 0,
							[`avergePurchasePrice${this.rawCardamomId}`]:
								c.providerItems.find(e => e.itemId === this.rawCardamomId)?.avergePurchasePrice ?? 0,
							
							// seeds
							[this.seedsId]: this.getItemById(this.seedsId)?.name ?? '-',
							[`totalWeight${this.seedsId}`]:
								c.providerItems.find(e => e.itemId === this.seedsId)?.totalWeight ?? 0,
							[`avergePurchasePrice${this.seedsId}`]:
								c.providerItems.find(e => e.itemId === this.seedsId)?.avergePurchasePrice ?? 0,
						}))
					)
				}
				this.statistics = tableItems;
			}).finally(() => {
				this.loading = false;
			})
		},

		fetchItemStatistics () {
			this.loading = true;
			this.$store.dispatch('statistics/fetchAvailableToSellQuantities').then((data) => {
				const quantityKeys = [ 
					{ nameStatistics: this.$T('weighted-average-percentage'), key: 'weightedAveragePercentage' },
					{ nameStatistics: this.$T('expected-quantity') + ' (Kg)', key: 'expectedQuantity' }, 
					{ nameStatistics: this.$T('inventory-qty') + ' (Kg)', key: 'inventoryQuantity' }, 
					{ nameStatistics: this.$T('reserved-quantity') + ' (Kg)', key: 'reservedQuantity' },
					{ nameStatistics: this.$T('available-to-sell') + ' (Kg)', key: 'availableToSell' }
				]

				const tableItems = quantityKeys.map((key, index) => {
					const rowData = this.itemsHeaders.reduce((res, header) => {
						res[header.value] = index !== 0 ? toKiloGram(data.find(c => c.itemId === header.value)?.[key.key] ?? 0) : (fixNumber(data.find(c => c.itemId === header.value)?.[key.key] ?? 0, 3)) + '%';
						return res;
					}, {});

					let totalRow = 0;
					if (index !== 0) {
						totalRow = fixNumber(Object.values(rowData).reduce((sum, value) => sum + Number(value), 0));
					} else {
						totalRow = fixNumber(Object.values(rowData).reduce((sum, value) => sum + parseFloat(value), 0), 3)
						if (+totalRow > 99.95) {
							totalRow = 100 + '%'
						} else {
							totalRow = totalRow + '%'
						}
					}

					return {
						statistics: key.nameStatistics,
						...rowData,
						totalRow: totalRow,
						isLast: index === quantityKeys.length - 1
					}
				});
				this.statistics = tableItems
			}).finally(() => {
				this.loading = false
			})
		}
	},

	created() {
		this.filter();
	}
}
</script>

<style>
.divider-before td {
  border-top: 2.4px solid green;
  font-size: 60px;
}
</style>